module.exports = __webpack_public_path__ + "97b8f704654531ab3651.worklet.js";